const isWebpSupported = true;
export default isWebpSupported;
